import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { PaymentComponent } from './payment/payment.component';
import { ProfileComponent } from './profile/profile.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { AuthGuard } from "./guard/auth-guard";
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { SelectCriteriaComponent } from './select-criteria/select-criteria.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AddAdvertisementComponent } from './add-advertisement/add-advertisement.component';
import { PerpetualAddComponent } from './perpetual-add/perpetual-add.component';
import { BasePaymentComponent } from './base-payment/base-payment.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdvertisementsComponent } from './advertisements/advertisements.component';
import { SettingsComponent } from './settings/settings.component';
import { AddBuyGetActionComponent } from './add-buy-get-action/add-buy-get-action.component';
import { MySubscrationComponent } from './my-subscration/my-subscration.component';
import { CampusGreetingsComponent } from './campus-greetings/campus-greetings.component';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import { MyPostcardComponent } from './my-postcard/my-postcard.component';
import { CrossChatComponent } from './cross-chat/cross-chat.component';
import { MinistryPostcardsComponent } from './ministry-postcards/ministry-postcards.component';
import { GetMyPostcardsComponent } from './get-my-postcards/get-my-postcards.component';
import { GetMyEventsComponent } from './get-my-events/get-my-events.component';
import { CreateEventComponent } from './create-event/create-event.component';
import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component';
import { AddPhotoGalleryComponent } from './add-photo-gallery/add-photo-gallery.component';
import { EnterpreneurResourceComponent } from './enterpreneur-resource/enterpreneur-resource.component';
import { BannerAdsListComponent } from './banner-ads-list/banner-ads-list.component';
import { AddBannerAdsComponent } from './add-banner-ads/add-banner-ads.component';
import { MyBannerPlansComponent } from './my-banner-plans/my-banner-plans.component';
import { MyAdsComponent } from './my-ads/my-ads.component';
import { UpdateEventsComponent } from './update-events/update-events.component';
import { FollowersListComponent } from './my-network/followers/followers-list.component';
import { MinistriesListComponent } from './my-network/affiliation/ministries-list.component';
import { CreateJobComponent } from './create-job/create-job.component';
import { MyJobsComponent } from './my-jobs/my-jobs.component';
import { HousingHubComponent } from './housing-hub/housing-hub.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { LeadsComponent } from './leads/leads.component';
const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'sign-in', component: SignInComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'sign-up', component: RegisterComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'plans', component: SubscriptionComponent, canActivate: [AuthGuard] },
  { path: 'payment', component: PaymentComponent, canActivate: [AuthGuard] },
  { path: 'user-registration', component: UserRegistrationComponent, canActivate: [AuthGuard] },
  // Public profile by username (supports URLs like `#/profile/vineetios`)
  { path: 'profile/:businessUserName', component: ProfileComponent },
  { path: 'update-profile', component: UpdateProfileComponent, canActivate: [AuthGuard] },
  { path: 'email-verification', component: EmailVerificationComponent },
  { path: 'select-criteria', component: SelectCriteriaComponent, canActivate: [AuthGuard] },
  { path: 'payment-sucess', component: PaymentSuccessComponent, canActivate: [AuthGuard] },
  { path: 'add-advertisement', component: AddAdvertisementComponent, canActivate: [AuthGuard] },
  { path: 'advertisements', component: AdvertisementsComponent, canActivate: [AuthGuard] },
  { path: 'perpetual-add', component: PerpetualAddComponent, canActivate: [AuthGuard] },
  { path: 'base-payment', component: BasePaymentComponent, canActivate: [AuthGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
  { path: 'mysubscration', component: MySubscrationComponent, canActivate: [AuthGuard] },
  { path: 'add-and-buy', component: AddBuyGetActionComponent, canActivate: [AuthGuard] },
  { path: 'campus-greetings', component: CampusGreetingsComponent, canActivate: [AuthGuard] },
  { path: 'my-postcard', component: GetMyPostcardsComponent, canActivate: [AuthGuard], },
  { path: 'create-my-postcards', component: MyPostcardComponent, canActivate: [AuthGuard] },
  { path: 'cross-chat', component: CrossChatComponent, canActivate: [AuthGuard] },
  {path: 'analytics', component: AnalyticsComponent, canActivate: [AuthGuard] },
  { path: 'ministry-postcard', component: MinistryPostcardsComponent, canActivate: [AuthGuard] },
  { path: 'my-events', component: GetMyEventsComponent, canActivate: [AuthGuard] },
  { path: 'create-my-event', component: CreateEventComponent, canActivate: [AuthGuard] },
  { path: 'update-my-event', component: UpdateEventsComponent, canActivate: [AuthGuard]},
  { path: 'photo-gallery', component: PhotoGalleryComponent, canActivate: [AuthGuard] },
  { path: 'add-photo-gallery', component: AddPhotoGalleryComponent, canActivate: [AuthGuard] },
  { path: 'enterpreneur-resource', component: EnterpreneurResourceComponent, canActivate: [AuthGuard] },
  { path: 'banner-ads', component: BannerAdsListComponent, canActivate: [AuthGuard] },
  { path: 'add-banner-ads', component: AddBannerAdsComponent, canActivate: [AuthGuard] },
  { path: 'my-banner-plans', component: MyBannerPlansComponent, canActivate: [AuthGuard] },
  { path: 'my-ads', component: MyAdsComponent, canActivate: [AuthGuard] },
  { path: 'my-network/followers', component: FollowersListComponent, canActivate: [AuthGuard] },
  { path: 'my-network/affiliation', component: MinistriesListComponent, canActivate: [AuthGuard] },
  { path: 'create-job', component: CreateJobComponent, canActivate: [AuthGuard] },
  { path: 'my-jobs', component: MyJobsComponent, canActivate: [AuthGuard] },
  { path: 'leads', component: LeadsComponent, canActivate: [AuthGuard] },
  { path: 'housing-hub', component: HousingHubComponent, canActivate: [AuthGuard] },
  { path: ':businessUserName', component: ProfileComponent },

];

@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, { enableTracing: false, useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
